export enum LoginAuthStep {
  Step1LoginPage = 1,
  Step2MfaCodeEntryPage = 2,
  Step3MfaSetupPage = 3,
}
